import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  {
    id: "home",
    title: "Home",
    translate: "MENU.HOME",
    type: "item",
    icon: "home",
    url: "dashboard/main",
    order: 1,
  },
  {
    id: "address-book",
    title: "Rubrica",
    translate: "MENU.ADDRESS_BOOK",
    type: "item",
    icon: "bookmark",
    url: "dashboard/address-book",
    order: 3,
  },
  {
    id: "refunds",
    title: "Rimborsi",
    translate: "MENU.REFUNDS",
    type: "item",
    icon: "credit-card",
    url: "dashboard/my-refunds",
    order: 5,
  },
  // i miei documenti
  {
    id: "my-documents",
    title: "I miei documenti",
    translate: "MENU.MY_DOCUMENTS",
    type: "item",
    icon: "file-text",
    url: "dashboard/my-documents",
    order: 6,
  },
  // assenze
  {
    id: "absence-users-list-general",
    title: "Ferie, Permessi e Malattie",
    translate: "MENU.ABSENCES_USERS_LIST",
    type: "collapsible",
    icon: "thermometer",
    capability: "",
    children: [
      {
        id: "absence-users-list",
        title: "Lista",
        translate: "LIST",
        type: "item",
        url: "dashboard/absence/list-user",
      },
      {
        id: "absence-users-list",
        title: "Richiedi ferie",
        translate: "MENU.REQUEST_HOLIDAYS",
        type: "item",
        url: "#toggleAbsencePopup-holidays",
      },
      {
        id: "absence-users-list",
        title: "Richiedi permesso",
        translate: "MENU.REQUEST_PERMISSION",
        type: "item",
        url: "#toggleAbsencePopup-permissions",
      },
      {
        id: "absence-users-list",
        title: "Richiedi malattia",
        translate: "MENU.REQUEST_SICKNESS",
        type: "item",
        url: "#toggleAbsencePopup-sickness",
      },
    ],
    order: 9,
  },
  // commesse
  {
    id: "commissions",
    title: "Economics",
    translate: "MENU.ECONOMICS_DATA",
    type: "collapsible",
    capability: "show_menu_commission_general",
    icon: "file-text",
    children: [
      {
        id: "commission-deals",
        title: "Offerte",
        translate: "MENU.DEALS",
        type: "item",
        url: "dashboard/deals/list",
        capability: "show_menu_deals",
        order: 2,
      },
      {
        id: "commission",
        title: "Commesse",
        translate: "MENU.COMMISSION",
        type: "item",
        url: "dashboard/commission/list",
        capability: "show_menu_commission",
        order: 3,
      },
      {
        id: "commissions-stats",
        title: "Statistiche commesse",
        translate: "MENU.COMMISSIONS_STATS",
        type: "item",
        url: "dashboard/commission/analytics",
        capability: "show_menu_stats_commissions",
        order: 4,
      },
      {
        id: "economic-balance",
        title: "Bilancio economico",
        translate: "MENU.ECONOMIC_BALANCE",
        type: "item",
        url: "dashboard/economic-balance",
        capability: "show_menu_economic_balance",
        order: 5,
      },
    ],
    order: 13,
  },
  // gestione dipendenti
  {
    id: "manage-users",
    title: "Gestione Utenti",
    translate: "MENU.USERS",
    type: "collapsible",
    capability: "show_menu_users",
    icon: "users",
    children: [
      {
        id: "employee",
        title: "Dipendenti",
        translate: "MENU.EMPLOYEE_LIST",
        type: "collapsible",
        capability: "show_menu_users",
        order: 1,
        children: [
          {
            id: "users-employee-list",
            title: "Lista",
            translate: "LIST",
            type: "item",
            capability: "show_menu_employee_list",
            url: "dashboard/user/list/employee",
            order: 1,
          },
          {
            id: "contract-list",
            title: "Contratti",
            translate: "MENU.CONTRACT_LIST",
            type: "item",
            capability: "show_menu_contract_list",
            url: "dashboard/contract-list",
            order: 2,
          },
          {
            id: "planning-list",
            title: "Planning",
            translate: "PLANNING",
            type: "item",
            capability: "show_menu_planning_list",
            url: "dashboard/planning-list",
            order: 5,
          },
        ],
      },
      {
        id: "future-employees",
        title: "Dipendenti Futuri",
        translate: "MENU.FUTURE_EMPLOYEE",
        type: "item",
        capability: "view_future_employees",
        url: "dashboard/user/future-employees",
        order: 2,
      },
      {
        id: "resigned-employees",
        title: "Dipendenti dimissionari",
        translate: "MENU.RESIGNED_EMPLOYEE",
        type: "item",
        capability: "view_resigned_employees",
        url: "dashboard/user/resigned-employees",
        order: 3,
      },
      {
        id: "list-groups",
        title: "Gruppi",
        translate: "MENU.GROUPS",
        type: "item",
        capability: "show_menu_groups_list",
        url: "dashboard/groups",
        order: 6,
      },
      {
        id: "users-ex-employee-list",
        title: "Ex dipendenti",
        translate: "MENU.EX_EMPLOYEE_LIST",
        type: "item",
        capability: "show_menu_ex-employee_list",
        url: "dashboard/ex-employees/list",
        order: 99,
      },
    ],
    order: 20,
  },
  // gestione
  {
    id: "settings",
    title: "Gestione",
    translate: "MENU.MANAGE",
    type: "item",
    icon: "settings",
    capability: "show_menu_settings",
    url: "dashboard/platform-management",
    order: 21,
  },
  // configurazione
  {
    id: "configuration",
    title: "Configurazioni",
    translate: "CONFIGURATIONS.CONFIGURATIONS",
    type: "item",
    icon: "sliders",
    capability: "show_menu_configuration",
    url: "dashboard/configurations",
    order: 22,
  },
  // tutorial
  {
    id: "tutorials-list-user",
    title: "Tutorial",
    translate: "MENU.TUTORIAL",
    type: "item",
    icon: "airplay",
    url: "dashboard/tutorials",
    order: 23,
  },
];


export const collaboratorMenu: CoreMenu[] = [
  {
    id: "home",
    title: "Home",
    translate: "MENU.HOME",
    type: "item",
    icon: "home",
    url: "dashboard/main",
    order: 1,
  },
  // i miei documenti
  {
    id: "my-documents",
    title: "I miei documenti",
    translate: "MENU.MY_DOCUMENTS",
    type: "item",
    icon: "file-text",
    url: "dashboard/my-documents",
    order: 6,
  },
];


